<div [formGroup]="newContactgroup" [class.contact__form-disabled]="newContactgroup.disabled" class="contact__grid">
  <div>
    <h3><b>CONTACT DETAILS</b></h3>
    <mat-form-field>
      <mat-label comFormLabelName="salutation">Salutation</mat-label>
      <mat-select formControlName="salutation" id="salutation" class="contact__control" title="Salutation">
        <mat-option value=""></mat-option>
        @for (sal of salutations; track $index) {
          <mat-option [value]="sal.key">{{ sal.value }}</mat-option>
        }
      </mat-select>
      <mat-error comFormMessageName="salutation">Required</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="positionHeld">Position Held</mat-label>
      <input matInput formControlName="positionHeld" id="positionHeld" class="contact__control" type="text" title="Position Held" />
      <mat-error comFormMessageName="positionHeld">Required</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="firstName">First Name</mat-label>
      <input matInput formControlName="firstName" id="firstName" class="contact__control" type="text" title="First Name" />
      <mat-error comFormMessageName="firstName">Required</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="lastName">Last Name</mat-label>
      <input matInput formControlName="lastName" id="lastName" class="contact__control" type="text" title="Last Name" />
      <mat-error comFormMessageName="lastName">Required</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="mobile">Mobile</mat-label>
      <input matInput formControlName="mobile" id="mobile" class="contact__control" type="text" title="Mobile" comNumbersOnly />
      <mat-error comFormMessageName="mobile">You must enter only numbers</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="phone">Telephone</mat-label>
      <input matInput formControlName="phone" id="phone" class="contact__control" type="text" title="Phone" comNumbersOnly />
      <mat-error comFormMessageName="phone" validation="required">Required</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="email">Email</mat-label>
      <input matInput formControlName="email" id="email" class="contact__control" type="text" title="Email" />
      <mat-error comFormMessageName="email" validation="required">Required</mat-error>
      <mat-error comFormMessageName="email" validation="pattern">The email format is incorrect</mat-error>
      <mat-error comFormMessageName="email" validation="emailExists">This email address is already in use</mat-error>
    </mat-form-field>

    <div class="checkbox">
      <mat-checkbox formControlName="isRegulatoryContact" id="isRegulatoryContact">Is Regulatory Contact </mat-checkbox>
      @if (providerTypeString === 'PRS') {
        <mat-checkbox formControlName="isDirector" id="isDirector">Is Director </mat-checkbox>
      }
      @if (providerTypeString === 'RADIO') {
        <mat-checkbox formControlName="isSQUContact" id="isSQUContact">Is SQU Contact </mat-checkbox>
      }
    </div>
  </div>

  <div>
    <h3><b>BUSINESS ADDRESS INFORMATION</b></h3>
    <mat-form-field>
      <mat-label comFormLabelName="addressLine1">Address Line 1</mat-label>
      <input matInput formControlName="addressLine1" id="addressLine1" class="contact__control" type="text" title="Address 1" />
      <mat-error comFormMessageName="addressLine1">Required</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="addressLine2">Address Line 2</mat-label>
      <input matInput formControlName="addressLine2" id="addressLine2" class="contact__control" type="text" title="Address 2" />
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="addressLine3">Address Line 3</mat-label>
      <input matInput formControlName="addressLine3" id="addressLine3" class="contact__control" type="text" title="Address 3" />
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="addressLine4">Address Line 4</mat-label>
      <input matInput formControlName="addressLine4" id="addressLine4" class="contact__control" type="text" title="Address 4" />
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="postCode">Postcode</mat-label>
      <input matInput formControlName="postCode" id="postCode" class="contact__control" type="text" title="Post Code" />
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="country">Country</mat-label>
      <mat-select formControlName="country" id="country" class="contact__control" title="Country">
        <mat-option value=""></mat-option>
        @for (country of countries; track $index) {
          <mat-option [value]="country.name">{{ country.name }}</mat-option>
        }
      </mat-select>
      <mat-error comFormMessageName="country">Required</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label comFormLabelName="county">County</mat-label>
      <mat-select formControlName="county" id="county" class="contact__control" title="County">
        <mat-option value=""></mat-option>
        @for (county of counties; track $index) {
          <mat-option [value]="county.key">{{ county.value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <h3><b>ONLINE ACCESS</b></h3>

    <acc-contact-permissions
      #contactPermissions
      [permissionSet]="permissionSet"
      [applicationPermissions]="applicationPermissions"
      [formDisabled]="false"
    ></acc-contact-permissions>

    @if (showErrorCreateContact) {
      <div [innerHtml]="errorMessages | arrayToList"></div>
    }
  </div>
</div>
<div class="buttons">
  <button mat-raised-button class="button--secondary button--pad-right" [routerLink]="'/accounts/details/contacts'">CANCEL</button>
  <button mat-raised-button [disabled]="!newContactgroup.valid" (click)="save()">ADD NEW CONTACT</button>
</div>
